import { render } from "./FooterNew.vue?vue&type=template&id=e72e3aec&scoped=true"
const script = {}

import "./FooterNew.vue?vue&type=style&index=0&id=e72e3aec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72e3aec"]])

export default __exports__